import React from "react";
import { useNavigate } from "react-router-dom";

const AddMoreItems = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="ksm:px-1.5 kmd:px-3 kxl:px-6 ksm:py-1 kmd:py-1.5 kxl:py-3 ksm:text-[15px] kmd:text-30 klg:text-[40px] kxl:text-60 rounded-full bg-white font-semibold text-custom-gray-400"
      onClick={() => navigate("/")}
    >
      Add More Items
    </button>
  );
};

export default AddMoreItems;
